import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	dismissAriaLabel: {
		id: 'offerBanner.dismiss.ariaLabel',
		defaultMessage: 'close',
		description: 'Accessible label for the button that dismisses the promo banner',
	},
	annualTitle: {
		id: 'offerBanner.annual.title',
		defaultMessage: 'Black Friday Sale: Get 50% off Calm Premium for a limited time!',
		description: 'Banner text for the 50% off annual Black Friday offer',
	},
	annualCta: {
		id: 'offerBanner.annual.cta',
		defaultMessage: 'Get Offer Now',
		description: 'Banner call to action for the 50% off annual Black Friday offer',
	},
	firstMonthTitle: {
		id: 'offerBanner.firstMonth.title',
		defaultMessage: 'Black Friday Sale: Get Calm Premium for $1 for 1 month for a limited time!',
		description: 'Banner text for the $1 first month Black Friday offer',
	},
	firstMonthCta: {
		id: 'offerBanner.firstMonth.cta',
		defaultMessage: 'Get Offer Now',
		description: 'Banner call to action for the $1 first month Black Friday offer',
	},
});
